// @import dependencies
// @end

// @import event types
import { IShoppingCarItem } from 'app_types/shoppingCart/shoppingCarTypes';
import { AuthActionTypes, ISidebarComponentState, SCREEN_MODE, EXPAND, ISidebarState, SIDEBAR_MENU_SELECTED, SIDEBAR_COMPONENT, IChatbotState, CHATBOT_CHANGE, IHelpStepsState, HELPSTEPS_CHANGE, SHOPPING_CAR_CHANGE, IActionsCart } from './types';
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @add your events

/*===============================================
=            Estructura de un metodo            =
================================================
  // La estructura de un metodo debe ser la siguiente:
  export const methodName = () => {}
/*======  End of Estructura de un metodo  =====*/

export function expand(state: boolean): AuthActionTypes {

  return {
    type: EXPAND,
    payload: state,
  }
}

export function collapse(state: boolean): AuthActionTypes {
  return {
    type: EXPAND,
    payload: state,
  }
}

export function sidebarMenuSelected({ selected = '' }: ISidebarState): AuthActionTypes {
  return {
    type: SIDEBAR_MENU_SELECTED,
    payload: selected,
  }
}

export function sidebarComponentSelected(payload: ISidebarComponentState): AuthActionTypes {
  return {
    type: SIDEBAR_COMPONENT,
    payload: payload,
  }
}

export function changeScreenMode(mode: string): AuthActionTypes {
  return {
    type: SCREEN_MODE,
    payload: mode,
  }
}

export function chatbotChange(payload: IChatbotState): AuthActionTypes {
  return {
    type: CHATBOT_CHANGE,
    payload
  }
}

export function helpStepsChange(payload: IHelpStepsState): AuthActionTypes {
  return {
    type: HELPSTEPS_CHANGE,
    payload
  }
}

export function shoppingCarChange(payload: {action: IActionsCart, data: IShoppingCarItem[]}): AuthActionTypes {
  return {
    type: SHOPPING_CAR_CHANGE,
    payload
  }
}

//@end
